import styled from "styled-components";

export default styled.div`
  & {
    width: 100%;
    height: 100%;
  }

  .section {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
  }

  .filter-section {
    display: flex;
    justify-content: space-between; /* Espaça os 4 filtros uniformemente */
    margin-bottom: 20px;
    padding: 10px;
  }

  .filter-input {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .filter-input label {
    font-weight: bold;
    color: ${(props) => props.theme.colors.black || "#000"};
  }

  .filter-input input {
    padding: 5px;
    border: 1px solid ${(props) => props.theme.colors.gray || "#ccc"};
    border-radius: 4px;
    width: 150px; /* Reduzi a largura para caber 4 filtros */
    font-size: 14px;
  }

  .filter-input input:focus {
    outline: none;
    border-color: ${(props) => props.theme.colors.primary || "#007bff"};
    box-shadow: 0 0 5px ${(props) => props.theme.colors.primary || "#007bff"};
  }

  .header-with-sort {
    display: flex;
    justify-content: space-between; /* Espaça o título e o ícone */
    align-items: center;
    padding: 8px; /* Ajuste de padding padrão da tabela */
  }

  .sort-button {
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    color: ${(props) => props.theme.colors.gray || "#666"};
  }

  .sort-button:hover {
    color: ${(props) => props.theme.colors.primary || "#007bff"};
  }
`;
